<template>
  <div class="container">
    <header class="header">
      <div class="center">
        <i class="back"></i>
      </div>
    </header>
    <div class="abs-address"><address-com/></div>
    <div class="goods-info">
      <order-module-title title="商品信息"/>
      <ul>
        <li>
          <booking-order-com/>
          <order-service-list style="margin-top: 10px"/>
        </li>
      </ul>
    </div>
    <div class="after-sale-reson f28">
      <span class="bold">申请原因：</span>
      <span class="grey6">请选择</span>
    </div>
    <div class="reson-desc">
      <h1 class="f28 bold">问题描述：</h1>
      <div contenteditable="true" class="textarea f28"></div>
    </div>
    <div class="upload-img">
      <h1 class="f28 bold">上传图片：</h1>
      <div>

      </div>
    </div>
    <div class="submit"><button class="primary" size="large">提交</button></div>
  </div>
</template>

<script>
  export default {
    name: 'afterSale',
    data () {
      return {
        color: [
          { id: 1 },
          { id: 2 }
        ],
        size: [
          {
            id: 1
          },
          {
            id: 2
          }
        ]
      }
    },
    created () {
    },
    methods: {
    }
  }
</script>

<style scoped lang="scss">
  .container{
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: 108px;
    .header{
      width: 100%;
      height: 200px;
      background: url('/images/order/order-header-bg.png') no-repeat center;
      .center{
        padding: 30px 30px 0 30px;
        display: flex;
        justify-content: space-between;
        .back{
          width: 60px;
          height: 60px;
          background: url('/images/public/back.png') no-repeat center;
          background-size: 60px;
        }
        .status{
          width: 170px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .status-text{
            color: #fff;
          }
        }
      }
    }
    .abs-address{
      position: absolute;
      top: 124px;
    }
    .goods-info{
      margin-top: 166px;
      padding: 0 30px;
      ul{
        margin: 30px 0;
        li{
          margin-bottom: 20px;
          padding-left: 20px;
          &:last-child{
            margin: 0;
          }
        }
      }
    }
    .after-sale-reson{
      width: 100%;
      height: 98px;
      border-top: 2px solid #eee;
      border-bottom: 2px solid #eee;
      display: flex;
      justify-content: space-between;
      align-items: center;
      span{
        margin: 0 30px 0 50px;
        &:last-child{
          padding-right: 30px;
          background: url("/images/public/arrow-right.png") no-repeat center right;
          background-size: 14px 22px;
        }
      }
    }
    .upload-img, .reson-desc{
      padding: 0 30px 0 50px;
      height: 376px;
      border-bottom: 2px solid #eee;
      h1{
        width: 670px;
        padding: 30px 0;
        line-height: 40px;
      }
      .textarea{
        width: 610px;
        height: 210px;
        padding: 20px;
        border-radius: 6px;
        background: #F5F5F5;
        outline: none;
        text-indent: 20px;
      }
    }
    .upload-img{
      div{
        width: 670px;
        height: 200px;
        display: flex;
        justify-content: space-between;
      }
    }
    .submit{
      width: 690px;
      position: fixed;
      bottom: 30px;
    }
  }
</style>
